import { jsx as _jsx } from "react/jsx-runtime";
import { setActiveEventRoute } from './activeEvent';
import { Route } from './routerDependencies';
export function FaroRoute(props) {
    var _a;
    if ((_a = props === null || props === void 0 ? void 0 : props.computedMatch) === null || _a === void 0 ? void 0 : _a.isExact) {
        setActiveEventRoute(props.computedMatch.path);
    }
    return _jsx(Route, Object.assign({}, props));
}
//# sourceMappingURL=FaroRoute.js.map